import fetch from '../utils/fetch'

export function getInstanceList (query) {
  return fetch({
    url: '/baoxian/getInstanceList',
    method: 'get',
    params: query
  })
}
export function save (params) {
  return fetch({
    url: '/baoxian/save',
    method: 'post',
    data: params
  })
}
export function del (insurance_id) {
  return fetch({
    url: '/baoxian/del/' + insurance_id,
    method: 'delete'

  })
}
export function edit (insurance_id, params) {
  return fetch({
    url: '/baoxian/edit' + insurance_id,
    method: 'put',
    data: params
  })
}




// WEBPACK FOOTER //
// ./src/api/commercial_insurance.js